<template>
  <div>
    <el-row type="flex" justify="space-between" class="mb15">
      <el-col :span="12">
        <strong>模板类型:</strong>
        <el-select
          v-model="ruleForm.url"
          placeholder="请选择"
          @change="handleChange()"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="3">
        <el-button
          v-auth="'/onlineSchool/addMenu'"
          type="primary"
          class="mb15"
          @click="
            popType = '新增';
            dialogVisible = true;
            ruleForm.title = '';
            ruleForm.linkUrl = '';
          "
          >新增导航</el-button
        >
      </el-col>
    </el-row>

    <el-card>
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        class="menuTable"
        tooltip-effect="dark"
        :data="menuList"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column
          prop="title"
          label="导航名称"
          min-width="40%"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="enabled"
          label="状态"
          align="center"
          min-width="25%"
        >
          <template slot-scope="scope">
            <el-switch
              v-if="scope.row.foreverExist != 1"
              v-model="scope.row.enabled"
              :active-value="1"
              :inactive-value="-1"
              @change="updateSwitching(scope.row)"
              class="switchStyle"
            ></el-switch>
            <div v-else>展示</div>
          </template>
        </el-table-column>
        <el-table-column min-width="25%" label="操作" align="center">
          <template slot-scope="scope">
            <el-link
              v-auth="'/onlineSchool/updateMenu'"
              type="primary"
              :underline="false"
              @click="editMenu(scope.row)"
            >
              编辑
            </el-link>
            <el-popconfirm
              icon="el-icon-info"
              icon-color="red"
              title="确定删除这条数据吗？"
              @confirm="deleteSure(scope.row)"
            >
              <el-link
                type="primary"
                :underline="false"
                slot="reference"
                v-auth="'/onlineSchool/deleteMenu'"
                >删除</el-link
              >
            </el-popconfirm>
            <el-link
              v-auth="'/onlineSchool/synAgentSchoolPageMenu'"
              type="primary"
              :underline="false"
              @click="synAgentSchoolPageMenu(scope.row.id)"
            >
              更新
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!--新增编辑弹框-->
    <el-dialog :title="popType" :visible.sync="dialogVisible" width="40%">
      <el-form
        :model="ruleForm"
        :rules="rules"
        style="width: 70%"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="导航类型">
          <el-radio-group v-model="ruleForm.type">
            <el-radio :label="1">路由</el-radio>
            <el-radio :label="2">外链接地址</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="导航类型2">
          <el-radio-group v-model="ruleForm.displayType">
            <el-radio :label="1">菜单</el-radio>
            <el-radio :label="2">页面</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="导航类型3">
          <el-radio-group v-model="ruleForm.classificationType">
            <el-radio :label="3">hover类型</el-radio>
            <el-radio :label="2">其他</el-radio>
            <el-radio :label="1">课程分类</el-radio>
            <el-radio :label="4">锚点</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="ruleForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="导航名称" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="副标题" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="锚点" prop="name">
          <el-input v-model="ruleForm.anchorPoint"></el-input>
        </el-form-item>

        <el-form-item label="链接地址" prop="linkUrl">
          <el-input v-model="ruleForm.linkUrl"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUrlSure('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      ids: [],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      menuList: [],
      searchForm: {},
      loading: false,
      dialogVisible: false,
      popType: "",
      options: [
        {
          value: "/",
          label: "首页",
        },
        {
          value: "/allCourse",
          label: "全部课程",
        },
        {
          value: "/agentAbroad",
          label: "机构入驻",
        },
      ],

      ruleForm: {
        type: 1,
        displayType: 1,
        classificationType: 2,
        linkUrl: "",
        title: "",
        sort: "",
        name: "",
        anchorPoint: undefined,
        //    其他接口用的参数
        enabled: 1,
        forever_exist: -1,
        url: "/",
        id: "",
      },
      rules: {
        title: [{ required: true, message: "请输入导航名称", trigger: "blur" }],
        linkUrl: [
          { required: true, message: "请输入链接地址", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    },
  },
  methods: {
    synAgentSchoolPageMenu(id) {
      this.api.schoolPage
        .synAgentSchoolPageMenu({
          id,
        })
        .then((res) => {});
    },
    pageList() {
      this.api.schoolPage
        .getMenuList({
          url: this.ruleForm.url,
        })
        .then((result) => {
          this.menuList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleChange() {
      this.pageList();
    },
    editMenu(row) {
      this.ruleForm.id = row.id;
      this.popType = "编辑";
      this.dialogVisible = true;
      this.api.schoolPage
        .getMenuDetail({
          id: row.id,
        })
        .then((result) => {
          this.ruleForm.type = result.data.type;
          this.ruleForm.sort = result.data.sort;
          this.ruleForm.displayType = result.data.displayType;
          this.ruleForm.classificationType = result.data.classificationType;
          this.ruleForm.title = result.data.title;
          this.ruleForm.name = result.data.name;
          this.ruleForm.anchorPoint = result.data.anchorPoint;
          this.ruleForm.linkUrl = result.data.linkUrl;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addUrlSure(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm);
          //新增or编辑
          if (this.popType == "新增") {
            this.api.schoolPage
              .addMenu(this.ruleForm)
              .then((result) => {
                this.dialogVisible = false;
                this.pageList();
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            this.api.schoolPage
              .updateVideoCourse(this.ruleForm)
              .then((result) => {
                this.dialogVisible = false;
                this.pageList();
              })
              .catch((error) => {
                console.log(error);
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteSure(row) {
      this.api.schoolPage
        .deleteMenu([{ id: row.id }])
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message({
              type: "error",
              message: result.message,
            });
            this.pageList();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateSwitching(row) {
      this.api.schoolPage
        .menuSwitch({
          id: row.id,
          enabled: row.enabled,
          url: this.ruleForm.url,
        })
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message({
              type: "error",
              message: result.message,
            });
            this.pageList();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {},
  mounted() {
    this.pageList();
  },
};
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/onlineSchool/menuSetting.vue